import "./src/styles/tailwindcss.css"
import "./src/styles/global.scss"
import './src/styles/navbar.scss'
import "./src/styles/top-menu.scss"
import "./src/styles/footer-menu.scss"
import "./src/styles/footer.scss"
import "./src/styles/shortcut.scss"